// ✅ Trekkin.app — TrekkinButton.jsx v2.0.1 (WEB + NATIVE OK)
// 🔹 Mantém comportamento visual e de clique
// 🔹 Remove hack /www/ que partia Capacitor
// 🔹 Usa sempre BASE_URL do Vite (web) + fallback neutro "/"

export default function TrekkinButton({
  as = "button",
  icon,
  variant = "default",
  active = false,
  onClick,
  style = {},
  className: extraClassName = "",
  size = 22,
  disabled = false,
  square = false,
  compactLabel = "",
  type = "button",
  children,
}) {
  const Tag = as;
  const hasChildren = Boolean(children);

  // 👉 BASE ÚNICA para Web + Android + iOS
  // - Web produção: BASE_URL = "/app/" → /app/icons/...
  // - Build nativa (base: "./"): BASE_URL = "./" → ./icons/... → https://localhost/icons/...
  const base = import.meta.env.BASE_URL || "/";

  const actionColors = {
    primary: "#28a745",
    danger: "#dc3545",
    warning: "#f59e0b",
  };
  const isAction = active || ["primary", "danger", "warning"].includes(variant);
  const bg = disabled
    ? "var(--tk-button-disabled-bg, rgba(200,200,200,0.75))"
    : active
    ? "#28a745"
    : actionColors[variant] || "var(--tk-button-bg, rgba(255,255,255,0.95))";

  const border = isAction ? "none" : "1.5px solid var(--tk-button-border, rgba(0,0,0,0.12))";
  const imgFilter = isAction ? "brightness(0) invert(1)" : "var(--tk-button-icon-filter, none)";
  const resolvedClassName = [
    "trekkin-button",
    `trekkin-button-${variant}`,
    active ? "trekkin-button-active" : "",
    disabled ? "trekkin-button-disabled" : "",
    square ? "trekkin-button-square" : "",
    extraClassName,
  ].filter(Boolean).join(" ");

  return (
    <Tag
      className={resolvedClassName}
      type={Tag === "button" ? type : undefined}
      onClick={disabled ? undefined : onClick}
      disabled={Tag === "button" ? disabled : undefined}
      aria-label={compactLabel || undefined}
      style={{
        background: bg,
        border,
        cursor: disabled ? "default" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        ...(square
          ? compactLabel && !hasChildren
            ? {
                width: 44,
                height: 44,
                minWidth: 44,
                minHeight: 44,
                borderRadius: 9,
                padding: "3px 2px",
                flex: "none",
                flexDirection: "column",
                gap: 1,
                textAlign: "center",
                overflow: "hidden",
                boxSizing: "border-box",
              }
            : hasChildren
            ? {
                minWidth: 110,
                minHeight: 110,
                borderRadius: 12,
                padding: 8,
                flex: "none",
                flexDirection: "column",
                gap: 6,
                textAlign: "center",
              }
            : {
                width: 44,
                height: 44,
                borderRadius: 12,
                padding: 0,
                flex: "none",
              }
          : {
              flex: 1,
              padding: "10px 0",
              borderRadius: 8,
            }),

        ...style,
      }}
    >
      {icon && (
        <span
          aria-hidden="true"
          style={{
            width: compactLabel ? 20 : size,
            height: compactLabel ? 20 : size,
            minWidth: compactLabel ? 20 : size,
            minHeight: compactLabel ? 20 : size,
            display: "grid",
            placeItems: "center",
            flex: "0 0 auto",
            margin: compactLabel ? "0 auto" : undefined,
          }}
        >
          <img
            src={`${base}icons/${icon}`}
            alt=""
            style={{
              width: compactLabel ? Math.min(size, 18) : size,
              height: compactLabel ? Math.min(size, 18) : size,
              filter: imgFilter,
              pointerEvents: "none",
              display: "block",
              objectFit: "contain",
              objectPosition: "center",
              margin: "auto",
            }}
          />
        </span>
      )}

      {children}
      {compactLabel && !children && (
        <span
          style={{
            width: "100%",
            minHeight: 13,
            maxHeight: 14,
            overflow: "hidden",
            fontSize: 6.5,
            lineHeight: 1.02,
            fontWeight: 800,
            textAlign: "center",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
          }}
        >
          {compactLabel}
        </span>
      )}
    </Tag>
  );
}
